<template>
  <div class="kye-preview-video">
    <video v-if="isVideo" :src="url" controls></video>
    <audio v-else controls :src="url"></audio>
  </div>
</template>

<script>
export default {
  props: {
    fileItem: Object
  },
  data() {
    return {}
  },
  computed: {
    isVideo () {
      return ['mp4', 'mov'].includes(this.fileItem.extendName)
    },
    url () {
      // 文件中心视频文件增加参数
      if (this.isVideo && this.fileItem.bizCode && this.fileItem.bizId) {
        if (this.fileItem.url.indexOf('?') === -1) {
          return this.fileItem.url + '?enableContentRange=1'
        }
        return this.fileItem.url + '&enableContentRange=1'
      }
      return this.fileItem.url
    }
  },
}
</script>

<style lang="scss" scoped>
.kye-preview-video {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  video {
    width: 400px;
    height: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-preview/component/file-video.vue